<template>
  <div :id="'switch_' + id" class="switch-box" @click.prevent="changeValue()">
    <label class="switch">
      <input type="checkbox" :id="inputId" v-model="check" :disabled="disabled" />
      <span :class="sliderClass"></span>
    </label>
    <div class="switch-slot">
      <span v-if="label && label !== ''" class="switch-label">{{ label }}</span>
      <slot />
    </div>
  </div>
</template>

<script>
export default {
  name: "SwitchCheckBox",
  props: ["id", "checked", "rounded", "onChange", "disabled", "label"],
  data() {
    return {
      check: Boolean(this.checked)
    };
  },
  computed: {
    inputId() {
      return this.id || "switch-checkbox";
    },
    sliderClass() {
      return this.rounded ? "slider round" : "slider";
    }
  },
  watch: {
    check: function (val, oldVal) {
      if (val !== oldVal) {
        this.onChange(val);
      }
    }
  },
  methods: {
    changeValue() {
      this.check = !this.check;
    }
  }
};
</script>

<style scoped>
.switch-box {
  display: flex;
  justify-content: flex-start;
  align-content: center;
  flex-direction: row;
  width: 100%;
  margin: 15px 0;
}

.switch-slot {
  display: grid;
  align-items: center;
}

.switch {
  display: inline-block;
  position: relative;
  height: 34px;
  flex-basis: 70px;
  flex-grow: 0;
  flex-shrink: 0;
}

.switch-label {
  display: flex;
  align-items: center;
  min-height: 34px;
  flex-basis: calc(100% - 70px);
  flex-grow: 0;
  flex-shrink: 0;
}

.dark .switch-label {
  color: #f0f0f0;
}

.switch input {
  opacity: 0;
  width: 0;
  height: 0;
}

.slider {
  position: absolute;
  cursor: pointer;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: #ccc;
  transition: 0.4s;
  width: 60px;
}

.slider:before {
  position: absolute;
  content: "";
  height: 26px;
  width: 26px;
  left: 4px;
  bottom: 4px;
  background-color: white;
  transition: 0.4s;
}

input:checked + .slider {
  background-color: var(--colors-light-primary-navy-blue);
}

input:disabled + .slider {
  background-color: var(--colors-light-support-success);
}

input:checked + .slider:before {
  transform: translateX(26px);
}

.slider.round {
  border-radius: 34px;
}

.slider.round:before {
  border-radius: 50%;
}
</style>
